import React, { ChangeEvent } from "react";
import { Field, FormikHelpers } from "formik";
import { Box, Button, Dialog } from "@mui/material";

import { ICode } from "../types";
import { getSuffix } from "../utils";
import { FormInput } from "../../index";

interface IProps {
  code: ICode;
  submitForm: () => void;
  setFieldValue: FormikHelpers<ICode>["setFieldValue"];
  isSavingCode: boolean;
}

const BatchCreateNTimes = ({
  code,
  submitForm,
  setFieldValue,
  isSavingCode,
}: IProps): React.ReactElement => {
  const handleClickCancel = () => setFieldValue("isBatchCreate", false);
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const suffix = getSuffix(e.target.value);
    setFieldValue("suffix", suffix);
    setFieldValue("times", +e.target.value);
  };

  return (
    <Dialog open={code.isBatchCreate}>
      <Box padding="30px" bgcolor="rgb(247, 247, 247)">
        <Field
          component={FormInput}
          name="times"
          type="number"
          label="N times"
          onChange={handleChange}
        />
        <Box mt="5px" display="flex" justifyContent="space-between">
          <Button size="small" disabled={!code.times || isSavingCode} onClick={submitForm}>
            Ok
          </Button>
          <Button size="small" onClick={handleClickCancel} disabled={isSavingCode}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BatchCreateNTimes;
